//Helpers
import { socket_send } from './socket_commands';

/**
 * Abstraction for making a request for Zendure devices over socket
 * @param id - Device ID
 * @param params - Request parameters
 * @returns - Response object
 */
export const zendureRequest = async (id: string, params: {}) => {
	let res: {
		isok: boolean;
		error?: unknown;
		data?: unknown;
	} = undefined;

	try {
		res = await socket_send(
			id,
			params,
			'Shelly:XPRequest',
			'xpz_solarflow_setlimit',
			undefined /* viaq */,
			20000,
		);
	} catch (error) {
		if (error.error === 'Timeout') {
			res = error;
		}
	} finally {
		if (typeof res !== 'undefined') {
			// change result key with data for unification
			if (res?.hasOwnProperty('result')) {
				res = { ...res, ['data']: res['result'] };
				delete res['result'];
			}
			// include isok property if missing
			if (!res?.hasOwnProperty('isok')) {
				res = {
					isok: !res?.hasOwnProperty('error') && res?.data?.success,
					...res,
				};
			}
		} else {
			res = { isok: false, error: 'Unknown error' };
		}
	}

	return res;
};
